import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
  arrowBtn: {
    '& > span': {
      fontSize: 0,
    }
  },
  menuItem: {
    minHeight: 'auto!important',
  },
  currencyToggle: {
    paddingLeft: 20,
  },
  wrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
    '@media (max-width:767px)': {
      width: '100%',
      justifyContent: 'flex-end',
    },
    '@media (min-width:768px)': {
      width: 'max-content',
      justifyContent: 'flex-start',
    },
  }
});
